export default __webpack_public_path__ + "static/media/box_jump.a0736e7b.gif";